<template>
	<v-container v-if="$vuetify.breakpoint.mdAndUp" fluid style="max-width: 1296px">
		<v-row style="padding-top: 22px">
			<v-col cols="12">
				<v-card class="px-4 d-flex align-content-center" min-height="155">
					<v-row no-gutters align="center">
						<v-col cols="12" md="6" lg="4" xl="4" class="px-12 pb-8" style="padding-top: 20px">
							<v-row no-gutters align="center">
								<v-col cols="12">
									<v-row no-gutters justify="center" justify-md="start" justify-lg="start"
										justify-xl="start">
										<h1 style="font-size: 28px !important; font-family: AirNZ Sans Semibold !important">
											<b>{{ entity.firstName + " " + entity.lastName }}</b>
										</h1>
									</v-row>
									<v-row no-gutters justify="center" justify-md="start" justify-lg="start"
										justify-xl="start">
										<!-- <a style="font-size: 14px !important" href="#/profile" v-if="entity.percentagePersonal != 100">Complete or update your profile</a> -->
										<a style="font-size: 14px !important" href="#/profile">Complete or update your
											profile</a>
									</v-row>
								</v-col>
							</v-row>
						</v-col>

						<v-col cols="12" md="6" lg="8" xl="8" class="pt-4">
							<v-row align="start" justify="center" justify-lg="end" justify-xl="end">
								<v-col style="max-width: 120px; min-width: 98px">
									<v-row no-gutters align="start" justify="center" style="cursor: pointer;" @click="$router.push('/sales')">
										<div class="rounded-circle d-flex justify-center align-center mb-2" style="width: 70px; height: 70px; border: 3px solid #04a0a8">
											<v-icon class="icon-anz-airplane" color="duoSecondary" size="30"></v-icon>
										</div>
									</v-row>
									<v-row no-gutters align="center" justify="center">
										<p class="text-center" style="font-size: 14px; line-height: 17px">{{dashboard.salesLogged}} sales logged this month</p>
									</v-row>
								</v-col>
								<v-col style="max-width: 120px; min-width: 98px">
									<v-row no-gutters align="start" justify="center" style="cursor: pointer;" @click="$router.push('/training')">
										<div class="rounded-circle d-flex justify-center align-center mb-2" style="width: 70px; height: 70px; border: 3px solid #04a0a8">
											<v-icon class="duo-icon-training" color="duoSecondary" size="30"></v-icon>
										</div> 
									</v-row>
									<v-row no-gutters align="center" justify="center">
										<!-- <p class="text-center" style="font-size: 14px; line-height: 17px;">{{dashboard.completedModules + ' / ' + dashboard.allModules}} training modules completed</p> -->
										<p class="text-center" style="font-size: 14px; line-height: 17px;">{{dashboard.completedModules}} training modules completed</p>
									</v-row>
								</v-col>
								<v-col style="max-width: 120px; min-width: 98px">
									<v-row no-gutters align="start" justify="center" @click="takeTheTour">
										<v-btn elevation="0"
											class="rounded-circle d-flex justify-center align-center duoSecondary ml-2 mb-2"
											style="width: 70px; height: 70px">
											<v-icon color="white" size="43">mdi-play-circle-outline</v-icon>
										</v-btn>
									</v-row>
									<v-row no-gutters align="center" justify="center">
										<p class="text-center" style="font-size: 14px; line-height: 17px">Take the tour</p>
									</v-row>
								</v-col>
								<v-col style="max-width: 120px; min-width: 98px">
									<v-menu offset-y :close-on-content-click="false">
										<template v-slot:activator="{ on, attrs }">
											<v-row no-gutters align="start" justify="center">
												<v-btn @blur="markAsRead()" elevation="0" fab
													class="d-flex justify-center align-center ml-2 mb-2"
													style="width: 70px; height: 70px" v-bind="attrs" v-on="on">
													<img v-if="newMessage == true" width="70" height="70"
														src="/icon/icon-notification-bell.svg"
														style="position: absolute; z-index: 1;" />
													<img v-else width="70" height="70"
														src="/icon/icon-notification-bell-read.svg"
														style="position: absolute; z-index: 1;" />
												</v-btn>
											</v-row>
											<v-row no-gutters align="center" justify="center">
												<p class="text-center" style="font-size: 14px; line-height: 17px">
													Notifications</p>
											</v-row>
										</template>
										<v-list v-if="notifications.length > 0"
											style="max-width: 600px; max-height:600px; overflow-y: auto;">
											<v-list-item v-for="item in notifications" :key="item.id" inactive dense>
												<v-list-item-avatar
													:style="containsNotificationLink(item) == true ? 'cursor: pointer' : 'cursor: auto'"
													@click="onNotificationClick(item)" inactive>
													<v-icon color="#440099" v-text="'mdi-bell-outline'"></v-icon>
												</v-list-item-avatar>
												<v-list-item-content
													:style="containsNotificationLink(item) == true ? 'cursor: pointer' : 'cursor: auto'"
													@click="onNotificationClick(item)">
													<v-list-item-title class="subtitle-2"
														:style="{ fontWeight: (item.readFlag == true ? 'normal' : 'bold') }">{{ item.title }}<v-spacer />
													</v-list-item-title>
													<v-list-item-subtitle class="text-wrap">
														<p>{{ item.message }}</p>
													</v-list-item-subtitle>
												</v-list-item-content>
												<v-btn icon color="white" @click="dismiss(item)">
													<v-icon color="grey">mdi-close</v-icon>
												</v-btn>
											</v-list-item>
										</v-list>
										<v-list v-else style="max-width: 600px; max-height:600px; overflow-y: auto;">
											<v-list-item inactive dense>
												<v-list-item-avatar inactive>
													<v-icon color="#440099" v-text="'mdi-block-helper'"></v-icon>
												</v-list-item-avatar>
												<v-list-item-title>There are no notifications to display
												</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card>
			</v-col>

			<duo-tile @onClickEdit="showEditDialog(item)" @onClickHide="showDialogConfirmation('unpublish', item.id)"
				v-for="item in tileList" :map="item.map" :img="item.image" :img-only="item.imageOnly" :title="item.title"
				:content="item.content" :size="item.size" :key="item.id" :btn-label="item.buttonLabel" :type="item.linkType"
				:typeCreator="item.type" :link="item.link" @onClickDialog="showDashboardDialog(item)" />
			<v-dialog v-model="tourDialog" content-class="v-dialog--custom" persistent>
				<v-card height="100%">
					<v-card-text class="ma-0 pa-0" style="position: absolute; height: 100%">
						<div style="position: relative">
							<v-icon large color="white" style="position: absolute; right: 30px; top: 20px; z-index: 1;"
								@click="
									tourDialog = false;
								stopVideo();
								">mdi-close</v-icon>
						</div>
						<video width="100%" class="iframe-size" controls controlsList="nodownload">
							<source :src="$bucket + '/video/airnz-take-tour.mp4'" type="video/mp4">
						</video>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-row>
		<v-dialog v-model="dialogPopup.show" content-class="v-dialog--winners" width="850px" persistent>
            <v-card height="416px" style="background-color: white !important">
                <v-card-title class="pa-0 d-flex justify-space-between" :style="{ backgroundColor: '#2D2926', height: '66px',  }">
                    <div class="pl-12">
                        <span class="time-square" style="color: white; width: 100% !important; max-width: 100% !important;"><b>{{dialogPopup.title}}</b></span>
                    </div>
                    <div class="d-flex justify-end">
                        <v-icon large color="white" style="right: 15px;" @click="dialogPopup.show = false;">mdi-close</v-icon>
                    </div>
                </v-card-title>
                <v-card-text class="pa-0" height="100%">
                    <v-row no-gutters>
                        <v-col cols="5" class="ma-0 pa-0">
                            <v-img :src="dialogPopup.image" height="350px" width="100%"></v-img>
                        </v-col>
                        <v-col cols="7" class="ma-0 pa-0 d-flex align-center pl-10">
                            <div v-html="dialogPopup.content" class="text-wrap" style="color: black;"></div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
		<dashboard-dialog :title="dashboardDialog.title" :image="dashboardDialog.image" :show="dashboardDialog.show"
			:content="dashboardDialog.content" @onCloseDialog="closeDashboardDialog" />
		<dialog-video :show="videoDialog.show" :title="videoDialog.title" :link="videoDialog.link" @onCloseDialog="closeVideoDialog"/>
	</v-container>

	<dashboard-mobile v-else></dashboard-mobile>
</template>

<style scoped>
.fc-background {
	background-image: url(https://duonz.s3-ap-southeast-2.amazonaws.com/image/background/BDM.Map.BG.jpg);
	background-size: cover;
	background-position: center bottom;
}
.fc-font-title {
	font-family: 'AirNZ Black Italic';
	font-size: 37px;
}
.fc-font-content {
	font-size: 17px;
}
.fc-font-content-bold {
	font-size: 17px;
	font-weight: bold;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
	padding: 6px;
}

.v-list > .v-list-item:hover {
	text-decoration: none !important;
	background-color: #f0f0f0 !important;
}
</style>

<style scoped>
.time-square {
	font-size: 28px !important;
	font-family: "AirNZ Sans Regular" !important;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #2d2926;
	color: white;
	width: 44px;
	height: 49px;
	max-width: 44px;
	max-height: 49px;
}
.time-square-sm {
	font-size: 24px !important;
	font-family: "AirNZ Sans Regular" !important;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #2d2926;
	color: white;
	max-width: 29px;
	max-height: 32px;
}
.btn-dashboard {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid #2d2926 !important;
	background-color: #2d2926 !important;
	color: white !important;
	border-radius: 4px;
	opacity: 1;
}
.btn-dashboard-secondary {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid white !important;
	background-color: white !important;
	color: #2d2926 !important;
	border-radius: 4px;
	opacity: 1;
}
.v-card {
	background: rgba(255, 255, 255, 0.9) !important;
}
.duo-text {
	font-size: 17px;
}
.image-margin-1 {
	margin-top: 0px;
}
.image-margin {
	margin-top: 10px;
}
.btn-margin {
	margin-bottom: 20px;
	margin-left: 8px;
}
.title-banner-1 {
	position: absolute;
	top: 15px;
	left: 15px;
	background-color: transparent;
	width: 95%;
	color: white;
	font-size: 29px;
	font-family: AirNZ Sans Regular;
}
.desc-banner-1 {
	position: absolute;
	top: 21%;
	left: 15px;
	background-color: transparent;
	width: 80%;
	color: #2d2926;
	font-family: AirNZ Sans Regular;
	font-size: 17px;
}
.button-banner-1 {
	width: 120px;
	height: 30px !important;
	text-transform: none;
	margin-bottom: 20px;
	margin-left: 20px;
	font-family: AirNZ Sans Regular;
	font-size: 12px !important;
	background-color: #008392 !important;
}
.title-banner-2 {
	position: absolute;
	top: 15px;
	left: 15px;
	background-color: transparent;
	width: 48%;
	color: white;
	font-size: 29px;
	font-family: AirNZ Sans Regular;
}
.desc-banner-2 {
	position: absolute;
	top: 21%;
	left: 15px;
	background-color: transparent;
	width: 45%;
	color: #2d2926;
	font-family: AirNZ Sans Regular;
	font-size: 17px;
}
.button-banner-2 {
	width: 120px;
	height: 30px !important;
	text-transform: none;
	margin-bottom: 20px;
	margin-left: 20px;
	font-family: AirNZ Sans Regular;
	font-size: 12px !important;
	background-color: #008392 !important;
}
.title-banner-3 {
	position: absolute;
	top: 15px;
	left: 15px;
	background-color: transparent;
	width: 33%;
	color: white;
	font-size: 29px;
	font-family: AirNZ Sans Regular;
}
.desc-banner-3 {
	position: absolute;
	top: 21%;
	left: 15px;
	background-color: transparent;
	width: 31%;
	color: #2d2926;
	font-family: AirNZ Sans Regular;
	font-size: 17px;
}
.desc-banner-3-closing-soon {
	position: absolute;
	top: 54%;
	left: 1%;
	background-color: transparent;
	width: 31%;
	color: #2d2926;
	font-family: AirNZ Sans Regular;
	font-size: 14px;
}
.desc-banner-2-closing-soon {
	position: absolute;
	top: 53%;
	left: 1%;
	background-color: transparent;
	width: 41%;
	color: #2d2926;
	font-family: AirNZ Sans Regular;
	font-size: 14px;
}

.button-banner-3 {
	width: 120px;
	height: 30px !important;
	text-transform: none;
	margin-bottom: 20px;
	margin-left: 20px;
	font-family: AirNZ Sans Regular;
	font-size: 12px !important;

	background-color: #008392 !important;
}
.img-1 {
	max-width: 100%;
	max-height: 100% !important;
}
.img-2 {
	width: 66%;
}
/* .img-3{
	width:85%;
} */
.time-closing-soon-banner-2 {
	top: 35%;
	font-family: AirNZ Sans Regular;
	position: absolute;
	font-size: 28px;
}
.time-closing-soon-banner-3 {
	top: 37%;
	font-family: AirNZ Sans Regular;
	position: absolute;
	font-size: 28px;
}
.v-dialog--custom {
	width: 902px;
	height: 508px;
}
.v-dialog--winners {
	height: 416px;
}
.score-a-spot-title {
  height: 40px;
  font-size: 26px;
  font-family: "AirNZ Black Italic";
}


.iframe-size {
	/* height: 450px; */
	display: block;
	border: none;
	height: 100%;
	width: 100%;
	z-index: 2;
}
@media only screen and (max-width: 2560px) and (min-width: 1441px) {
	.image-margin-1 {
		margin-top: -20px;
	}
	/* .title-banner-1{
		font-size: 38px !important;
	}
	.desc-banner-1{
		font-size: 26px !important;
	}
	.title-banner-2{
		font-size: 30px !important;
	}
	.desc-banner-2{
		font-size: 24px;
	}
	.title-banner-3{
		font-size: 29px !important;
	}
	.desc-banner-3{
		font-size: 24px;
	} */
	.desc-banner-3-closing-soon {
		font-size: 16px;
		top: 55%;
	}
	.desc-banner-2-closing-soon {
		font-size: 16px;
		top: 55%;
	}
	/* .title-banner-1{
		font-size: 20px;
	}
	.desc-banner-1{
		font-size: 20px;
	} */
	/* .button-banner-1{
		width:200px;
		height:60px !important;
		margin-bottom:20px;
		margin-left:20px;
		font-family:AirNZ Sans Regular;
		font-size:20px !important;
	}
	.button-banner-2{
		width:200px;
		height:60px !important;
		margin-bottom:20px;
		margin-left:20px;
		font-family:AirNZ Sans Regular;
		font-size:20px !important;
		background-color: #008392 !important;
	}
	.button-banner-3{
		width:200px !important;
		height:60px !important;
		margin-bottom:20px;
		margin-left:20px;
		font-family:AirNZ Sans Regular;
		font-size:20px !important;
	} */
}
@media only screen and (max-width: 1440px) and (min-width: 1023px) {
	.image-margin-1 {
		margin-top: -20px;
	}
	/* 	.title-banner-1{
		font-size: 14px !important;
	}
	.desc-banner-1{
		font-size: 12px !important;
	}
	.title-banner-2{
		font-size: 16px;
	}
	.desc-banner-2{
		font-size: 12px !important;
	}
	.title-banner-2{
		font-size: 16px;
	}
	.desc-banner-2{
		font-size: 13px;
	}
	.title-banner-3{
		font-size: 16px;
	}
	.desc-banner-3{
		font-size: 12px;
	} */
	.desc-banner-3-closing-soon {
		top: 54%;
		font-size: 10px;
	}
	.desc-banner-2-closing-soon {
		top: 54%;
		font-size: 10px;
	}
	/* .title-banner-1{
		font-size: 20px;
	}
	.desc-banner-1{
		font-size: 20px;
	} */
	/* .button-banner-1{
		width:100px;
		height:20px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:8px !important;
	}
	.button-banner-2{
		width:100px;
		height:20px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:8px !important;
	}
	.button-banner-3{
		width:100px;
		height:20px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:8px !important;
	} */
	.time-closing-soon-banner-2 {
		font-size: 20px;
	}
	.time-closing-soon-banner-3 {
		font-size: 18px;
	}
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
	.btn-hover {
		max-width: 100px !important;
	}
	/* .image-margin-1{
		margin-top:-20px;
	} */
	/* .title-banner-1{
		font-size: 14px !important;
	}
	.desc-banner-1{
		font-size: 12px !important;
	}
	.title-banner-2{
		font-size: 16px;
	}
	.desc-banner-2{
		font-size: 12px !important;
	}
	.title-banner-2{
		font-size: 16px;
	}
	.desc-banner-2{
		font-size: 13px;
	}
	.title-banner-3{
		font-size: 16px;
	}
	.desc-banner-3{
		font-size: 12px;
	}
	.title-banner-1{
		font-size: 20px;
	}
	.desc-banner-1{
		font-size: 20px;
	} */
	.desc-banner-3-closing-soon {
		top: 54%;
		font-size: 10px;
	}
	.desc-banner-2-closing-soon {
		top: 54%;
		font-size: 10px;
	}
	/* .button-banner-1{
		width:100px;
		height:20px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:8px !important;
	}
	.button-banner-2{
		width:100px;
		height:20px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:8px !important;
	}
	.button-banner-3{
		width:100px;
		height:20px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:8px !important;
	} */
	.time-closing-soon-banner-2 {
		font-size: 20px;
	}
	.time-closing-soon-banner-3 {
		font-size: 18px;
	}
}
@media only screen and (max-width: 767px) and (min-width: 426px) {
	.image-margin-1 {
		margin-top: -20px;
	}
	/* .title-banner-1{
		font-size: 8px;
	}
	.desc-banner-1{
		font-size: 7px;
	}
	.button-banner-1{
		width:60px;
		height:15px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:6px !important;
	}
	.title-banner-2{
		font-size: 8px;
	}
	.desc-banner-2{
		font-size: 7px;
	}
	.button-banner-2{
		width:60px;
		height:15px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:6px !important;
	}
	.title-banner-3{
		font-size: 8px;
	}
	.desc-banner-3{
		font-size: 6px;
	} */
	.desc-banner-3-closing-soon {
		top: 54%;
		font-size: 5px;
	}
	.desc-banner-2-closing-soon {
		top: 54%;
		font-size: 5px;
	}
	/* 	.button-banner-3{
		width:60px;
		height:15px !important;
		margin-bottom:5px;
		margin-left:5px;
		font-size:6px !important;
	} */
	.time-closing-soon-banner-2 {
		font-size: 12px;
	}
	.time-closing-soon-banner-3 {
		font-size: 12px;
	}
}
@media only screen and (max-width: 425px) {
	.btn-hover {
		max-width: 100px !important;
	}
	.image-margin-1 {
		margin-top: -20px;
	}
	.title-banner-1 {
		font-size: 17px;
		width: 400px;
	}
	.desc-banner-1 {
		font-size: 10px;
	}
	.button-banner-1 {
		width: 30px;
		height: 15px !important;
		margin-bottom: 3px;
		margin-left: 3px;
		font-size: 6px !important;
	}
	/* .title-banner-2{
		font-size: 8px;
		width:110px;
	}
	.desc-banner-2{
		font-size: 6px;
	} */
	.button-banner-2 {
		width: 50px;
		height: 15px !important;
		margin-bottom: 3px;
		margin-left: 3px;
		font-size: 6px !important;
	}
	/* .title-banner-3{
		font-size: 6.5px;
		width:150px;
	} */
	/* .desc-banner-3{
		font-size: 6px;
	} */
	.desc-banner-3-closing-soon {
		top: 49%;
		font-size: 4px;
	}
	.desc-banner-2-closing-soon {
		top: 49%;
		font-size: 4px;
	}
	.button-banner-3 {
		width: 50px;
		height: 15px !important;
		margin-bottom: 1px;
		margin-left: 3px;
		font-size: 6px !important;
	}
	.time-closing-soon-banner-2 {
		font-size: 10px;
	}
	.time-closing-soon-banner-3 {
		font-size: 8px;
	}
}
</style>

<script>
/* eslint-disable no-console */
import axios from "axios";
import dashboardDialog from "./dialog/dashboardDialog.vue";
import duoTile from "./creator/duoTile.vue"
import dialogVideo from "./dialog/dialogVideo.vue";
import dashboardMobile from "./mobile/dashboardMobile.vue";

export default {
	components: {
    dashboardDialog,
		duoTile,
		dialogVideo,
		dashboardMobile
    },
	data() {
		return {
			entity: {
				firstName: "",
				lastName: "",
				email: "",
				loginCount: null,
				map: {
					tourVideoFlag: false
				}
			},
			dashboard: {
			},
			tileList: [],
			dashboardDialog: {
				show: false,
				image: "/image/dashboard-dialogs/WinnersNYC.JPG",
				title: "Bound for NYC Incentive winners",
				content: "<p><b>Congratulations to all our winners from our recent <br/> Bound for NYC incentive, with eight lucky agents off <br/> to experience the best of New York city for five epic <br/> nights in May! </b></p><p>The lucky agents are Donna, Lisa, Brook, Sophie, Liam, Evan, Marissa and Melissa, and are all so excited to be headed to New York City with Air New Zealand, flying via Auckland.</p><p>All winners have now been contacted, and congratulations to the 40 spot prize winners throughout the campaign, taking home Apple AirTags and $100 eGift cards.</p><p>Keep an eye out on the New York highlights from the famil, and thank you again to everyone who entered. </p>"
			},
			description: "",
			title: "",
			percentage: 0,
			videoDialog: {
				show: false,
				link: "",
				title: ""
			},
			dialogPopup: {
                show: false,
                title: "",
                content: "",
                image: "",
            },
			tourDialog: false,
			birthdayDialog: false,
			notifications: [],
			newMessage: false
		};
	},
	mounted: function () {
		this.getList();
		this.profile();
		this.personDashboard();
		this.bookingPercentage();
		this.getNotification();
	},
	methods: {
		getList() {
			axios
				.get("/system/tile/dashboard")
				.then((response) => {
					this.tileList = response.data.filter(function (el) {
						return el.sequence;
					})
				})
				.catch(() => { });
		},
		profile() {
			axios
				.get("/system/person/me")
				.then((response) => {
					this.entity = response.data;
					this.tourVideo();
				})
				.catch(() => { });
		},
		personDashboard() {
			axios
				.get("/system/person/dashboard?excludedModuleList=" + this.getExcludedModules())
				.then((response) => {
					this.dashboard = response.data;
				})
				.catch(() => { });
		},
		getExcludedModules() {
			// Include excluded modules from duoTraining.vue, some training does not available for all
			let result = null;

			if (!this.$store.state.principal.email.endsWith('@airnz.co.nz') &&
				!this.$store.state.principal.email.endsWith('@tag-group.com') &&
				!this.$store.state.principal.email.endsWith('@travelbeyond.com.au')) {
				result = "91507";
			}

			return result;
		},
		bookingPercentage() {
			axios
				.get("/system/person/me/booking/percentage")
				.then((response) => {
					this.percentage = response.data;
				})
				.catch(() => { });
		},
		boundForNYCWinners() {
			this.dashboardDialog.show = true,
				this.$root.saveActivityLog({ type: 'Visit_dashboard_tile', value: "Bound for NYC winners" });
		},
		closeDashboardDialog() {
			this.dashboardDialog.show = false
		},
		showDashboardDialog(item) {
			if (item.linkType == "Popup") {
				this.dialogPopup.show = true;
				this.dialogPopup.title = item.map.popup.title;
				this.dialogPopup.content = item.map.popup.content;
				this.dialogPopup.image = item.map.popup.image;
			} else {
				this.videoDialog.link = item.link;
				this.videoDialog.title = item.reportTitle;
				this.videoDialog.show = true;
				this.$root.saveActivityLog({ type: 'Visit_dashboard_tile', value: item.reportTitle.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim() });
			}
		},
		takeTheTourTiles() {
			this.tourDialog = true;
			this.$root.saveActivityLog({ type: 'Visit_dashboard_tile', value: "Take the tour" });
		},
		takeTheTour() {
			this.videoDialog.link = this.$bucket + '/video/duonz-take-tour.mp4';
			this.videoDialog.title = "duo - we're better together";
			this.videoDialog.show = true;
		},
		tourVideo() {
			if ((this.entity.loginCount === 1 && !this.entity.map.tourVideoFlag) || !this.entity.map.toolkitVideoFlag) {
				this.takeTheTour();
				axios
					.get("/system/person/flagging/tour")
					.then((response) => {
						this.map = response.data.map;
					})
					.catch(() => { });
			}
		},
		closeVideoDialog() {
			this.videoDialog.show = false;
			this.stopVideo();
			this.videoDialog.link = ""
			this.videoDialog.title = "";
		},
		stopVideo() {
			// youtube
			var iframes = document.querySelectorAll("iframe");
			Array.prototype.forEach.call(iframes, (iframe) => {
				iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: "stopVideo" }), "*");
			});

			// mp4
			var videos = document.querySelectorAll('iframe, video');
			Array.prototype.forEach.call(videos, (video) => {
				if (video.tagName.toLowerCase() === 'video') {
					video.pause();
					video.currentTime = 0;
				} else {
					var src = video.src;
					video.src = src;
				}
			});
		},
		dismiss(item) {
			axios
				.post("/system/person/notification/dismiss", { id: item.id })
				.then(response => {
					if (response.status === 200) {
						this.notifications.splice(this.notifications.indexOf(item), 1);
					}
				})
				.catch(() => { });
		},
		async markAsRead() {
			if (this.newMessage == true && !this.$store.state.principal.impersonate) {
				this.notifications.forEach(item => {
					if (!item.readFlag || item.readFlag == false) {
						item.readFlag = true;
					}
				});

				axios
					.post("/system/person/notification/read", {})
					.then(() => {
						this.newMessage = false;
					})
					.catch(() => { });
			}
		},
		getNotification() {
			axios
				.get("/system/person/notification/list")
				.then(response => {
					this.notifications = response.data;
					if (this.notifications.length > 0) {
						// Sorted by read flag in BE, so only check first row
						if (!this.notifications[0].readFlag || this.notifications[0].readFlag == false) {
							this.newMessage = true;
						}
					}
				})
				.catch(() => { });
		},
		sendBannerAnalytics(url) {
			try {
				this.$gtm.trackEvent({
					event: 'click_banner_home',
					category: 'banner_home',
					action: 'click',
					label: url,
				});
			} catch (error) {
				// console.log(error);
			}
		},
		onNotificationClick(notification) {
			if (this.containsNotificationLink(notification)) {
				window.open(notification.transitMap.link, "_self");
			}
		},
		containsNotificationLink(notification) {
			return notification.transitMap.link && notification.transitMap.link.length > 0;
		}
	}
};
</script>